import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {AppProviders} from '@/app/AppProviders';
import {router} from '@/app/router';
import '@/styles/globals.css';
import {initInstallCapture} from '@/lib/pwa/install';

initInstallCapture();

if (import.meta.env.VITE_DEMO !== 'true') {
  void import('@/lib/pwa/register').then((m) => m.registerServiceWorker());
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
